import { useState } from "react";
import { ArticleDataObject } from "@app/types/Cue";
import axios from "axios";

export const useLoadMoreStoriesBySectionKeyword = (
  section: string,
  keyword: string,
  initialList: ArticleDataObject[],
  pageSize: number
) => {
  const [articleList, setArticleList] =
    useState<ArticleDataObject[]>(initialList);
  const [hasMoreArticles, setHasMoreArticles] = useState(
    initialList.length >= pageSize
  );

  const handleLoadMore = async () => {
    const lastArticle = initialList.at(-1);
    const sort = lastArticle?.sort;

    if (initialList.length === 0) return;
    if (typeof lastArticle === "undefined") return;
    if (typeof sort === "undefined") return;

    const newMoreArticles = await fetchStories(section, keyword, sort);

    if (newMoreArticles.length < pageSize) setHasMoreArticles(false);

    setArticleList((prev) => [...prev, ...newMoreArticles]);
  };

  return { articleList, handleLoadMore, hasMoreArticles };
};

const fetchStories = async (
  section: string,
  keyword: string,
  sort: (string | number)[]
) => {
  try {
    const response = await axios.post(
      "/_plat/api/v1/more-stories-by-section-keywords",
      { section, keyword, sort, size: 10 }
    );

    return response?.data || [];
  } catch (error) {
    console.log("error on fetchStories"); // eslint-disable-line no-console
    return [];
  }
};
